// Internal module imports
import { HttpClient } from '../utils/httpClient';

const PATH = {
    read: '/root/eic/redis-data',
    logs: '/root/eic/logs',
    powerLogs: '/root/eic/power-logs',
    updateRedisValue: '/root/eic/redis-value',
    eicCodes: '/root/eic/eic-codes',
    eicLogs: '/root/eic/eic-logs',
    eicSignalLogs: '/root/eic/eic-signal-logs',
    edxCommunicationLogs: '/root/eic/edx-communication-logs',
    activationEvents: '/root/eic/activation-events',
    activationEventsByArea: '/root/eic/activation-events-area',
    activationEdgeEventsByArea: '/root/eic/activation-edge-events-area',
    activationEdgeEvents: '/root/eic/activation-edge-events',
};

const GetRedisData = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.read, { params }).then(callback).catch(error).finally(next);
};
const GetLogs = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.logs, { params }).then(callback).catch(error).finally(next);
};

const GetPowerLogs = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.powerLogs, { params }).then(callback).catch(error).finally(next);
};

const UpdateRedisValue = (payload, start, callback, error, next) => {
    start();
    return HttpClient.patch(`${PATH.updateRedisValue}`, payload).then(callback).catch(error).finally(next);
};

const GetEicCodes = (start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.eicCodes).then(callback).catch(error).finally(next);
};

const GetEicLogs = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.eicLogs, { params }).then(callback).catch(error).finally(next);
};

const GetEicSignalLogs = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.eicSignalLogs, { params }).then(callback).catch(error).finally(next);
};

const GetEdxCommunicationLogs = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.edxCommunicationLogs, { params }).then(callback).catch(error).finally(next);
};

const GetActivationEvents = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.activationEvents, { params }).then(callback).catch(error).finally(next);
};
const GetActivationByArea = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.activationEventsByArea, { params }).then(callback).catch(error).finally(next);
};

const GetEdgeActivationByArea = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.activationEdgeEventsByArea, { params }).then(callback).catch(error).finally(next);
};

const GetActivationEdgeEvents = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.activationEdgeEvents, { params }).then(callback).catch(error).finally(next);
};

export const RootAfrrService = {
    GetRedisData,
    GetLogs,
    GetPowerLogs,
    UpdateRedisValue,
    GetEicCodes,
    GetEicLogs,
    GetEicSignalLogs,
    GetEdxCommunicationLogs,
    GetActivationEvents,
    GetActivationByArea,
    GetEdgeActivationByArea,
    GetActivationEdgeEvents,
};
